import {isEmpty, merge} from 'lodash';

import Assessment from '../assessment';
import AssessmentResult from '../../../values/AssessmentResult';
import {EXTERNAL_LINKS_ID, LINK_RECOMMEND_POINTS} from '@axyseo/const/analysis';

/**
 * Assessment for calculating the outbound links in the text.
 */
export default class OutboundLinksAssessment extends Assessment {
  /**
   * Sets the identifier and the config.
   *
   * @param {Object} [config] The configuration to use.
   *
   * @returns {void}
   */
  constructor(config = {}) {
    super();

    const defaultConfig = {
      id: EXTERNAL_LINKS_ID,
      docUrl:
        'https://docs.avada.io/seo-suite-help-center/seo-on-page-audit/checklist#missing-external-links',
      fixPosition: 'description',
      title: 'External links',
      priority: 'high',
      content: {
        improve: '',
        good: 'External links are used effectively.',
        bad: 'No external links found. Add relevant links to be more authoritative and informative.'
      }
    };

    this.identifier = EXTERNAL_LINKS_ID;
    this._config = merge(defaultConfig, config);
  }

  /**
   * Runs the getLinkStatistics module, based on this returns an assessment result with score.
   *
   * @param {Paper}       paper       The paper to use for the assessment.
   * @param {Researcher}  researcher  The researcher used for calling research.
   *
   * @returns {AssessmentResult} The assessment result.
   */
  getResult({paper, researcher}) {
    const linkStatistics = researcher.getResearch('getLinkStatistics');
    const assessmentResult = new AssessmentResult({config: this._config});

    const calculatedResult = this.calculateResult(linkStatistics);

    if (!isEmpty(linkStatistics)) {
      assessmentResult.setScore(calculatedResult.score);
      assessmentResult.setStatus(calculatedResult.status);
    }
    return assessmentResult;
  }

  /**
   * Checks whether paper has text.
   *
   * @param {Paper}       paper       The paper to use for the assessment.
   *
   * @returns {boolean} True when there is text.
   */
  isApplicable(paper) {
    return true;
  }

  /**
   *
   * @param linkStatistics
   * @returns {{score: number, status: string}}
   */
  calculateResult(linkStatistics) {
    let status = 'good';
    if (linkStatistics.externalTotal === 0) {
      status = 'bad';
    }

    const score = this.getScore(LINK_RECOMMEND_POINTS, status);

    return {
      score,
      status
    };
  }
}
